define.alias("shared/components/shared/modal", "settings/components/shared/modal");